module.exports = __webpack_public_path__ + "static/media/Logo Lightbulb.a85d7f98.svg";